import { z } from '@harvestiq/zod';

export const checkAuth0UserExistsRequestBodySchema = z.object({
  email: z.string().email(),
  recaptchaToken: z.string().min(1),
});

export type CheckAuth0UserExistsRequestBody = z.infer<
  typeof checkAuth0UserExistsRequestBodySchema
>;

export const checkAuth0UserExistsResponseSchema = z
  .object({
    next: z.string(),
  })
  .or(
    z.object({
      errors: z.array(
        z.object({
          message: z.string(),
        })
      ),
    })
  );

export type CheckAuth0UserExistsResponse = z.infer<
  typeof checkAuth0UserExistsResponseSchema
>;
